import { FC, useState } from 'react';
import cx from 'classnames';
import { TABLE_ITEMS_CLASSNAMES } from 'core/constants';
import ButtonConfirmCircle from 'shared/components/Buttons/ButtonActionCircle/ButtonConfirmCircle';
import ButtonRejectCircle from 'shared/components/Buttons/ButtonActionCircle/ButtonRejectCircle';
import { changeStatusManualOpportunity } from 'redux/opportunities-service/action';
import { connect, ConnectedProps } from 'react-redux';
import { OPPORTUNITY_STATUSES } from '@joc/api-gateway';
import styles from '../CellDefault.module.scss';
import ButtonPencil from '../../../Buttons/ButtonPencil';
import ReasonForRejectionPopup from 'components/Organization/Opportunities/OpportunityPopups/ReasonForRejectionPopup';

type ManualOpportunityActionsParentProps = {
	opportunityId: number;
	editClickHandler?: () => void;
};

const ManualOpportunityActions: FC<ManualOpportunityActionsProps> = ({
	changeStatusManualOpportunity,
	editClickHandler,
	opportunityId,
}: ManualOpportunityActionsProps) => {
	const [isShowRejectionPopup, setIsShowRejectionPopup] = useState(false);

	const handleRejectConfirm = (reason: string) => {
		// reason can be empty string since it's optional
		const rejectionReason = reason.trim() || undefined;
		changeStatusManualOpportunity(opportunityId, OPPORTUNITY_STATUSES.CANCELED, rejectionReason);
	};

	return (
		<>
			<div
				className={cx(styles.main, styles[TABLE_ITEMS_CLASSNAMES.options], {
					[styles.options__manual]: !!editClickHandler,
				})}
			>
				{editClickHandler ? (
					<ButtonPencil
						clickHandler={editClickHandler}
						parentClassName={!!editClickHandler ? styles.options__manual__edit : ''}
					/>
				) : null}
				<ButtonConfirmCircle
					parentClassName={!!editClickHandler ? styles.options__manual__confirm : ''}
					clickHandler={() => changeStatusManualOpportunity(opportunityId, OPPORTUNITY_STATUSES.OPEN)}
				/>
				<ButtonRejectCircle
					parentClassName={!!editClickHandler ? styles.options__manual__confirm : ''}
					clickHandler={() => setIsShowRejectionPopup(true)}
				/>
			</div>
			{isShowRejectionPopup && (
				<ReasonForRejectionPopup setIsShowPopup={setIsShowRejectionPopup} onConfirm={handleRejectConfirm} />
			)}
		</>
	);
};

const mapDispatchToProps = {
	changeStatusManualOpportunity,
};

const connector = connect(null, mapDispatchToProps);

type ManualOpportunityActionsProps = ConnectedProps<typeof connector> & ManualOpportunityActionsParentProps;

export default connector(ManualOpportunityActions);
